import Locale from './Locale';
import Email from './Email';
import t from 'tcomb';

const Registered = t.struct({
  email: Email,
  com_locale: Locale,
  rcs_privacy_needed: t.Bool
}, 'Registered');

module.exports = Registered;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Registered.js
 **/